import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

export interface StripeListParams {
  entityType: "COMPANY" | "LOCATION";
  entityId: string;
  startingAfter?: string;
  endingBefore?: string;
  limit?: number;
}

export enum MarketplaceProduct {
  HIPAA_COMPLIANCE = "hipaa-compliance",
  PRIORITY_SUPPORT = "priority-support",
}

export interface MarketplacePurchaseQueryDto {
  type: MarketplaceProduct;
  enable: string;
  company_id: string;
  company_email: string;
}

export interface createLocationTransferRequestsDto {
  locationIds: string[];
  releasingCompanyRelNo: string;
  receivingCompanyRelNo: string;
}

export interface CompanyByRelationsipNumberDto{
  relationshipNumber: string;
}

const InternalToolsService = {
  setCompanyStatus: (payload: { companyId: string; status: string }) =>
    requests(SERVICE_NAME.INTERNAL_TOOLS_API).put("billing/company/status", payload),

  listCharges: (params: StripeListParams) =>
    requests(SERVICE_NAME.INTERNAL_TOOLS_API).get("billing/charges/list", {
      params,
    }),

  listInvoices: (params: StripeListParams) =>
    requests(SERVICE_NAME.INTERNAL_TOOLS_API).get("billing/invoices/list", {
      params,
    }),

  enableMarketplaceService: (params: MarketplacePurchaseQueryDto) =>
    requests(SERVICE_NAME.INTERNAL_TOOLS_API).get("support/marketplace/enable_service", {
      params,
    }),

  createLocationTransferRequests: (payload: createLocationTransferRequestsDto) =>
    requests(SERVICE_NAME.INTERNAL_TOOLS_API).post("location-transfers/bulk-transfer", payload),

  
  getCompanyByRelationshipNumber: (params: CompanyByRelationsipNumberDto) => 
    requests(SERVICE_NAME.INTERNAL_TOOLS_API).get("support/company-details", {
      params,
    }),
  

  initLogin: (payload: {
    loginBy: string;
    platform?: string;
    value: string;
    locationId?: string;
  }) => requests(SERVICE_NAME.INTERNAL_TOOLS_API).post("support/init-login", payload),
};
export default InternalToolsService;
